export default "__VITE_ASSET__DzxBx_6Z__"